export default __webpack_public_path__ + "static/industry-lifesciences-b5332f601afc59625dea9d18cde1b138.png";